import React from 'react';

export default function VideoOffIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#707578"
          d="M10.503.85c.32 0 .611.125.827.329l-.696.697c-.025-.018-.053-.032-.084-.038l-.047-.006H1.207c-.102 0-.19.071-.216.165l-.008.059v7.866c0 .101.07.189.165.215l.059.008h1.156l-.983.983h-.173c-.624 0-1.139-.476-1.2-1.083L0 9.922V2.056C0 1.433.476.917 1.084.856l.123-.007h9.296zm5.49 1.124l.007.082v7.866c0 .337-.328.566-.635.47l-.076-.03-3.58-1.79v1.35c0 .623-.476 1.138-1.083 1.2l-.123.006H4.16l.984-.983h5.359c.101 0 .189-.07.215-.164l.008-.06V4.564l.983-.982.353-.353 3.227-1.612c.301-.15.652.04.704.358zm-.977.876L11.71 4.504v2.967l3.307 1.654V2.85z"
          transform="translate(4 6)"
        />
        <path
          fill="red"
          fillRule="nonzero"
          d="M13.06.144c.192-.192.503-.192.695 0 .171.17.19.436.057.627l-.057.068-12.29 12.29c-.192.193-.503.193-.695 0-.171-.17-.19-.435-.057-.626l.057-.069L13.06.144z"
          transform="translate(4 6)"
        />
      </g>
    </svg>
  );
}
